import { useState } from "react";
import { supabase } from "../../../supabaseClient.jsx";
import { Card } from "../../../components/ui/card";
import { Button } from "../../../components/ui/button";
import { MessageCircle, Mail, Check, Loader2 } from "lucide-react";

// Contatos reais da Tesourinho's (mesma fonte usada no Footer / assinatura).
const WHATSAPP = import.meta.env.VITE_WHATSAPP_NUMBER || "5521996669205";
const EMAIL = "carla.tesourinhosadm@gmail.com";
const WHATSAPP_MSG =
  "Olá, sou assinante Tesourinho's e preciso de ajuda com...";

const ASSUNTOS = [
  "Dúvida sobre minha assinatura",
  "Problema com agendamento",
  "Outra dúvida",
];

export default function SuportePage({ familiaId }) {
  const [assunto, setAssunto] = useState(ASSUNTOS[0]);
  const [mensagem, setMensagem] = useState("");
  const [enviando, setEnviando] = useState(false);
  const [erro, setErro] = useState("");
  const [sucesso, setSucesso] = useState(false);

  const enviar = async () => {
    setErro("");
    if (!mensagem.trim()) {
      setErro("Escreva sua mensagem antes de enviar.");
      return;
    }
    if (!familiaId) {
      setErro("Sessão não encontrada. Faça login novamente.");
      return;
    }
    setEnviando(true);
    const { error } = await supabase.from("mensagens_suporte").insert({
      familia_id: familiaId,
      assunto,
      mensagem: mensagem.trim(),
    });
    setEnviando(false);
    if (error) {
      setErro("Não foi possível enviar sua mensagem. Tente novamente.");
      return;
    }
    setSucesso(true);
    setMensagem("");
  };

  return (
    <div className="space-y-4">
      <Card className="p-6">
        <h3 className="text-lg font-semibold text-foreground mb-1">
          Fale com a Tesourinho's
        </h3>
        <p className="text-sm text-muted-foreground mb-4">
          Nossa equipe está aqui para ajudar. Escolha o canal que preferir.
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
          <a
            href={`https://wa.me/${WHATSAPP}?text=${encodeURIComponent(WHATSAPP_MSG)}`}
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-3 rounded-xl border border-border p-4 transition hover:border-emerald-400 hover:bg-emerald-50/50"
          >
            <span className="flex h-10 w-10 items-center justify-center rounded-full bg-emerald-100 text-emerald-600">
              <MessageCircle size={20} />
            </span>
            <span>
              <span className="block text-sm font-semibold text-foreground">WhatsApp</span>
              <span className="block text-xs text-muted-foreground">Resposta mais rápida</span>
            </span>
          </a>

          <a
            href={`mailto:${EMAIL}`}
            className="flex items-center gap-3 rounded-xl border border-border p-4 transition hover:border-rose-400 hover:bg-rose-50/50"
          >
            <span className="flex h-10 w-10 items-center justify-center rounded-full bg-rose-100 text-rose-500">
              <Mail size={20} />
            </span>
            <span className="min-w-0">
              <span className="block text-sm font-semibold text-foreground">E-mail</span>
              <span className="block text-xs text-muted-foreground truncate">{EMAIL}</span>
            </span>
          </a>
        </div>
      </Card>

      <Card className="p-6">
        <h3 className="text-lg font-semibold text-foreground mb-1">
          Enviar uma mensagem
        </h3>
        <p className="text-sm text-muted-foreground mb-4">
          Preencha o formulário e retornaremos por WhatsApp ou e-mail.
        </p>

        {sucesso ? (
          <div className="flex items-center gap-3 rounded-xl border border-emerald-200 bg-emerald-50 p-4">
            <span className="flex h-9 w-9 items-center justify-center rounded-full bg-emerald-100 text-emerald-600 shrink-0">
              <Check size={18} />
            </span>
            <div>
              <p className="text-sm font-semibold text-emerald-700">Mensagem enviada!</p>
              <p className="text-xs text-emerald-600">Nossa equipe entrará em contato.</p>
            </div>
            <Button variant="outline" className="ml-auto" onClick={() => setSucesso(false)}>
              Enviar outra
            </Button>
          </div>
        ) : (
          <div className="space-y-3">
            <div>
              <label className="text-xs text-muted-foreground">Assunto</label>
              <select
                value={assunto}
                onChange={(e) => setAssunto(e.target.value)}
                className="mt-1 w-full rounded-lg border border-border px-3 py-2 text-sm bg-white"
              >
                {ASSUNTOS.map((a) => (
                  <option key={a} value={a}>{a}</option>
                ))}
              </select>
            </div>

            <div>
              <label className="text-xs text-muted-foreground">Mensagem</label>
              <textarea
                value={mensagem}
                onChange={(e) => setMensagem(e.target.value)}
                rows={4}
                placeholder="Como podemos ajudar?"
                className="mt-1 w-full rounded-lg border border-border px-3 py-2 text-sm resize-none"
              />
            </div>

            {erro && <p className="text-xs text-red-500">{erro}</p>}

            <Button onClick={enviar} disabled={enviando}>
              {enviando ? (
                <span className="flex items-center gap-2">
                  <Loader2 size={16} className="animate-spin" /> Enviando...
                </span>
              ) : (
                "Enviar mensagem"
              )}
            </Button>
          </div>
        )}
      </Card>
    </div>
  );
}
